export enum HorseMatrixType {
  Trainability = '[HorseMatrixType] Trainability',
  Willingness = '[HorseMatrixType] Willingness',
  Confidence = '[HorseMatrixType] Confidence',
  Curiosity = '[HorseMatrixType] Curiosity',
  Consistency = '[HorseMatrixType] Consistency',
  Patience = '[HorseMatrixType] Patience',
  Focus = '[HorseMatrixType] Focus',
  Sensitivity = '[HorseMatrixType] Sensitivity',
  FrontLegsBase = '[HorseMatrixType] FrontLegsBase',
  FrontKneesFrontView = '[HorseMatrixType] FrontKneesFrontView',
  FrontToes = '[HorseMatrixType] FrontToes',
  FrontLegsCamp = '[HorseMatrixType] FrontLegsCamp',
  FrontKneesSideView = '[HorseMatrixType] FrontKneesSideView',
  HindLegsStanding = '[HorseMatrixType] HindLegsStanding',
  Hocks = '[HorseMatrixType] Hocks',
  HindEnd = '[HorseMatrixType] HindEnd',
  PasternsFront = '[HorseMatrixType] PasternsFront',
  PasternsHind = '[HorseMatrixType] PasternsHind',
  FlightOfTraveFront = '[HorseMatrixType] FlightOfTraveFront',
  FlightOfTravelHind = '[HorseMatrixType] FlightOfTraveHind',
  BackSwayVsRoach = '[HorseMatrixType] BackSwayVsRoach',
  Chest = '[HorseMatrixType] Chest',
  LeftSideFlexion = '[HorseMatrixType] LeftSideFlexion',
  RightSideFlexion = '[HorseMatrixType] RightSideFlexion',
  ResponsivenessHoldsToBit = '[HorseMatrixType] ResponsivenessHoldsToBit',
  ResponsivenessRespondsToRein = '[HorseMatrixType] ResponsivenessRespondsToRein',
  ResponsivenessRespondsToLeg = '[HorseMatrixType] ResponsivenessRespondsToLeg',
  ResponsivenessRespondsToSeat = '[HorseMatrixType] ResponsivenessRespondsToSeat',
  ResponsivenessCollectionOfHorse = '[HorseMatrixType] ResponsivenessCollectionOfHorse',
  MaintainingEvenGaitsWalkToRight = '[HorseMatrixType] MaintainingEvenGaitsWalkToRight',
  MaintainingEvenGaitsTrotToRight = '[HorseMatrixType] MaintainingEvenGaitsTrotToRight',
  MaintainingEvenGaitsCanterRightLead = '[HorseMatrixType] MaintainingEvenGaitsCanterRightLead',
  MaintainingEvenGaitsWalkToLeft = '[HorseMatrixType] MaintainingEvenGaitsWalkToLeft',
  MaintainingEvenGaitsTrotToLeft = '[HorseMatrixType] MaintainingEvenGaitsTrotToLeft',
  MaintainingEvenGaitsCanterLopeToLeft = '[HorseMatrixType] MaintainingEvenGaitsCanterLopeToLeft',
  MaintainingEvenGaitsBack = '[HorseMatrixType] MaintainingEvenGaitsBack',
  MaintainingEvenGaitsHalt = '[HorseMatrixType] MaintainingEvenGaitsHalt',
  MaintainingCirclesWalkSmallRight = '[HorseMatrixType] MaintainingCirclesWalkSmallRight',
  MaintainingCirclesTrotRight = '[HorseMatrixType] MaintainingCirclesTrotRight',
  MaintainingCirclesWalkSmallLeft = '[HorseMatrixType] MaintainingCirclesWalkSmallLeft',
  MaintainingCirclesTrotLeft = '[HorseMatrixType] MaintainingCirclesTrotLeft',
  MaintainingCirclesCanterLargeRight = '[HorseMatrixType] MaintainingCirclesCanterLargeRight',
  MaintainingCirclesCanterLargeLeft = '[HorseMatrixType] MaintainingCirclesCanterLargeLeft',
  AdvancedRightSidePass = '[HorseMatrixType] AdvancedRightSidePass',
  AdvancedLeftSidePass = '[HorseMatrixType] AdvancedLeftSidePass',
  AdvancedRightHaunchTurn = '[HorseMatrixType] AdvancedRightHaunchTurn',
  AdvancedLeftHaunchTurn = '[HorseMatrixType] AdvancedLeftHaunchTurn',
  AdvancedRightForehandTurn = '[HorseMatrixType] AdvancedRightForehandTurn',
  AdvancedLeftForehandTurn = '[HorseMatrixType] AdvancedLeftForehandTurn',
  AdvancedTrotOff = '[HorseMatrixType] AdvancedTrotOff',
  AdvancedLopeOffRightLead = '[HorseMatrixType] AdvancedLopeOffRightLead',
  AdvancedLopeOffLeftLead = '[HorseMatrixType] AdvancedLopeOffLeftLead',
  AdvancedLeadChangeLtoR = '[HorseMatrixType] AdvancedLeadChangeLtoR',
  AdvancedLeadChangeRtoL = '[HorseMatrixType] AdvancedLeadChangeRtoL',
  AdvancedLopeToHalt = '[HorseMatrixType] AdvancedLopeToHalt',
  AdvancedFigure8Simple = '[HorseMatrixType] AdvancedFigure8Simple',
  AdvancedFigure8FlyingLead = '[HorseMatrixType] AdvancedFigure8FlyingLead',

  Box = '[HorseMatrixType] Box',
  Boxing = '[HorseMatrixType] Boxing',
  BoxWork = '[HorseMatrixType] BoxWork',
  RunAndRate = '[HorseMatrixType] RunAndRate',
  HandlingCattle = '[HorseMatrixType] HandlingCattle',
  Face = '[HorseMatrixType] Face',
  Stop = '[HorseMatrixType] Stop',
  Stops = '[HorseMatrixType] Stops',
  Position = '[HorseMatrixType] Position',
  WorkingRope = '[HorseMatrixType] WorkingRope',
  CalfRopingBoxWork = '[HorseMatrixType] CalfRopingBoxWork',
  LeftCircles = '[HorseMatrixType] LeftCircles',
  RightCircles = '[HorseMatrixType] RightCircles',
  LeftLeadChange = '[HorseMatrixType] LeftLeadChange',
  RightLeadChange = '[HorseMatrixType] RightLeadChange',
  LeftSpin = '[HorseMatrixType] LeftSpin',
  RightSpin = '[HorseMatrixType] RightSpin',
  Rollback = '[HorseMatrixType] Rollback',
  Backup = '[HorseMatrixType] Backup',
  HerdWork = '[HorseMatrixType] HerdWork',
  CowControl = '[HorseMatrixType] CowControl',
  EyeAppeal = '[HorseMatrixType] EyeAppeal',
  Courage = '[HorseMatrixType] Courage',
  LooseRein = '[HorseMatrixType] LooseRein',
  TurnsOnFence = '[HorseMatrixType] TurnsOnFence',
  Circling = '[HorseMatrixType] Circling',
  PositioningAndControl = '[HorseMatrixType] PositioningAndControl',
  BarrelHorseEvaluation = '[HorseMatrixType] BarrelHorseEvaluation',
  Rate = '[HorseMatrixType] Rate',
  ShoulderControl = '[HorseMatrixType] ShoulderControl',
  Approach = '[HorseMatrixType] Approach',
  Takeoff = '[HorseMatrixType] Takeoff',
  FormOverJump = '[HorseMatrixType] FormOverJump',
  Landing = '[HorseMatrixType] Landing',
  Recovery = '[HorseMatrixType] Recovery',
  Adjustability = '[HorseMatrixType] Adjustability',
  Rhythm = '[HorseMatrixType] Rhythm',
  Scope = '[HorseMatrixType] Scope',
  Movement = '[HorseMatrixType] Movement',
  JumpingStyle = '[HorseMatrixType] JumpingStyle',
  Technique = '[HorseMatrixType] Technique',
  Conformation = '[HorseMatrixType] Conformation',
  Temperament = '[HorseMatrixType] Temperament',
  Expression = '[HorseMatrixType] Expression',
  WayOfGoing = '[HorseMatrixType] WayOfGoing',
  Presence = '[HorseMatrixType] Presence',
  TrailObstacleNavigation = '[HorseMatrixType] TrailObstacleNavigation',
  TemperamentOnTrail = '[HorseMatrixType] TemperamentOnTrail',
  TrailConfidence = '[HorseMatrixType] TrailConfidence',
  TrailRidingManners = '[HorseMatrixType] TrailRidingManners',
  GroundManners = '[HorseMatrixType] GroundManners',
  EaseOfHandling = '[HorseMatrixType] EaseOfHandling',
  ToleranceForNewScenarios = '[HorseMatrixType] ToleranceForNewScenarios',
  Suppleness = '[HorseMatrixType] Suppleness',
  Collection = '[HorseMatrixType] Collection',
  Balance = '[HorseMatrixType] Balance',
  Impulsion = '[HorseMatrixType] Impulsion',
  Submission = '[HorseMatrixType] Submission',
  Connection = '[HorseMatrixType] Connection',
  Harmony = '[HorseMatrixType] Harmony',
  BarrelRacingRate = '[HorseMatrixType] BarrelRacingRate',
  BarrelRacingShoulderControl = '[HorseMatrixType] BarrelRacingShoulderControl',
  BarrelRacingHipControl = '[HorseMatrixType] BarrelRacingHipControl',
  BarrelRacingChangingLeads = '[HorseMatrixType]. BarrelRacingChangingLeads',
  BarrelRacingRespondsToSeat = '[HorseMatrixType].BarrelRacingRespondsToSeat',
  GroundWorkCatch = '[HorseMatrixType] GroundWorkCatch',
  GroundWorkLead = '[HorseMatrixType] GroundWorkLead',
  GroundWorkStandToSaddle = '[HorseMatrixType] GroundWorkStandToSaddle',
  GroundWorkAcceptBridle = '[HorseMatrixType] GroundWorkAcceptBridle',
  GroundWorkStandWhileMounting = '[HorseMatrixType] GroundWorkStandWhileMounting',
  GroundWorkLoadInTrailer = '[HorseMatrixType] GroundWorkLoadInTrailer',
  GroundWorkPickUpHandleFeet = '[HorseMatrixType] GroundWorkPickUpHandleFeet',
  GroundWorkGroomingClipping = '[HorseMatrixType] GroundWorkGroomingClipping'
}

export namespace HorseMatrixType {
  export function toString(type: HorseMatrixType): string {
    switch (type) {
      case HorseMatrixType.Trainability:
        return 'Trainability';
      case HorseMatrixType.Willingness:
        return 'Willingness';
      case HorseMatrixType.Confidence:
        return 'Confidence';
      case HorseMatrixType.Curiosity:
        return 'Curiosity';
      case HorseMatrixType.Consistency:
        return 'Consistency';
      case HorseMatrixType.Patience:
        return 'Patience';
      case HorseMatrixType.Focus:
        return 'Focus';
      case HorseMatrixType.Sensitivity:
        return 'Sensitivity';
      case HorseMatrixType.FrontLegsBase:
        return 'Front Legs Base';
      case HorseMatrixType.FrontKneesFrontView:
        return 'Front Knees Front View';
      case HorseMatrixType.FrontToes:
        return 'Front Toes';
      case HorseMatrixType.FrontLegsCamp:
        return 'Front Legs Camp';
      case HorseMatrixType.FrontKneesSideView:
        return 'Front Knees Side View';
      case HorseMatrixType.HindLegsStanding:
        return 'Hind Legs Standing';
      case HorseMatrixType.Hocks:
        return 'Hocks';
      case HorseMatrixType.HindEnd:
        return 'Hind End';
      case HorseMatrixType.PasternsFront:
        return 'Pasterns Front';
      case HorseMatrixType.PasternsHind:
        return 'Pasterns Hind';
      case HorseMatrixType.FlightOfTraveFront:
        return 'Flight of Travel (Front)';
      case HorseMatrixType.FlightOfTravelHind:
        return 'Flight of Travel (Hind)';
      case HorseMatrixType.BackSwayVsRoach:
        return 'Back Sway vs Roach';
      case HorseMatrixType.Chest:
        return 'Chest';
      case HorseMatrixType.LeftSideFlexion:
        return 'Left-side flexion';
      case HorseMatrixType.RightSideFlexion:
        return 'Right-side flexion';
      case HorseMatrixType.ResponsivenessHoldsToBit:
        return 'Responds to Bit';
      case HorseMatrixType.ResponsivenessRespondsToRein:
        return 'Responds to Rein';
      case HorseMatrixType.ResponsivenessRespondsToLeg:
        return 'Responds to Leg';
      case HorseMatrixType.ResponsivenessRespondsToSeat:
        return 'Responds to Seat';
      case HorseMatrixType.ResponsivenessCollectionOfHorse:
        return 'Moves with Collection';
      case HorseMatrixType.MaintainingEvenGaitsWalkToRight:
        return 'Walk to Right';
      case HorseMatrixType.MaintainingEvenGaitsTrotToRight:
        return 'Trot to Right';
      case HorseMatrixType.MaintainingEvenGaitsCanterRightLead:
        return 'Canter/Lope to Right';
      case HorseMatrixType.MaintainingEvenGaitsWalkToLeft:
        return 'Walk to Left';
      case HorseMatrixType.MaintainingEvenGaitsTrotToLeft:
        return 'Trot to Left';
      case HorseMatrixType.MaintainingEvenGaitsCanterLopeToLeft:
        return 'Canter/Lope to Left';
      case HorseMatrixType.MaintainingEvenGaitsBack:
        return 'Back';
      case HorseMatrixType.MaintainingEvenGaitsHalt:
        return 'Halt/Stop';
      case HorseMatrixType.MaintainingCirclesTrotLeft:
        return 'Maintaining Circles: Trot Left';
      case HorseMatrixType.MaintainingCirclesTrotRight:
        return 'Maintaining Circles: Trot Right';
      case HorseMatrixType.MaintainingCirclesCanterLargeRight:
        return 'Maintaining Circles: Canter Large Right';
      case HorseMatrixType.MaintainingCirclesCanterLargeLeft:
          return 'Maintaining Circles: Canter Large Left';
      case HorseMatrixType.MaintainingCirclesWalkSmallLeft:
          return 'Maintaining Circles: Walk Small Left';
      case HorseMatrixType.MaintainingCirclesWalkSmallRight:
        return 'Maintaining Circles: Walk Small Right';
      case HorseMatrixType.AdvancedRightSidePass:
        return 'Right Side Pass';
      case HorseMatrixType.AdvancedLeftSidePass:
        return 'Left Side Pass';
      case HorseMatrixType.AdvancedRightHaunchTurn:
        return 'Hind Leg Pivot Right';
      case HorseMatrixType.AdvancedLeftHaunchTurn:
        return 'Hind Leg Pivot Left';
      case HorseMatrixType.AdvancedRightForehandTurn:
        return 'Right Forehand Turn';
      case HorseMatrixType.AdvancedLeftForehandTurn:
        return 'Left Forehand Turn';
      case HorseMatrixType.AdvancedTrotOff:
        return 'Trot Off';
      case HorseMatrixType.AdvancedLopeOffRightLead:
        return 'Lope Off, Right Lead';
      case HorseMatrixType.AdvancedLopeOffLeftLead:
        return 'Lope Off, Left Lead';
      case HorseMatrixType.AdvancedLeadChangeLtoR:
        return 'Lead Change (L to R)';
      case HorseMatrixType.AdvancedLeadChangeRtoL:
        return 'Lead Change (R to L)';
      case HorseMatrixType.AdvancedLopeToHalt:
        return 'Lope to Stop';
      case HorseMatrixType.AdvancedFigure8Simple:
        return 'Figure 8 - Simple';
      case HorseMatrixType.AdvancedFigure8FlyingLead:
        return 'Figure 8 - Flying lead';
      case HorseMatrixType.Box:
        return 'Box';
      case HorseMatrixType.Boxing:
        return 'Boxing';
      case HorseMatrixType.BoxWork:
        return 'Box Work';
      case HorseMatrixType.CalfRopingBoxWork:
        return 'Box Work';
      case HorseMatrixType.RunAndRate:
        return 'Run And Rate';
      case HorseMatrixType.HandlingCattle:
        return 'Handling Cattle';
      case HorseMatrixType.Face:
        return 'Face';
      case HorseMatrixType.Stop:
        return 'Stop';
      case HorseMatrixType.Stops:
        return 'Stops';
      case HorseMatrixType.Position:
        return 'Position';
      case HorseMatrixType.WorkingRope:
        return 'Working Rope';
      case HorseMatrixType.LeftCircles:
        return 'Left Circles';
      case HorseMatrixType.RightCircles:
        return 'Right Circles';
      case HorseMatrixType.LeftLeadChange:
        return 'Left Lead Change';
      case HorseMatrixType.RightLeadChange:
        return 'Right Lead Change';
      case HorseMatrixType.LeftSpin:
        return 'Left Spin';
      case HorseMatrixType.RightSpin:
        return 'Right Spin';
      case HorseMatrixType.Rollback:
        return 'Rollback';
      case HorseMatrixType.Backup:
        return 'Backup';
      case HorseMatrixType.HerdWork:
        return 'Herd Work';
      case HorseMatrixType.CowControl:
        return 'Cow Control';
      case HorseMatrixType.EyeAppeal:
        return 'Eye Appeal';
      case HorseMatrixType.Courage:
        return 'Courage';
      case HorseMatrixType.LooseRein:
        return 'Loose Rein';
      case HorseMatrixType.TurnsOnFence:
        return 'Turns On Fence';
      case HorseMatrixType.Circling:
        return 'Circling';
      case HorseMatrixType.PositioningAndControl:
        return 'Positioning And Control';
      case HorseMatrixType.BarrelHorseEvaluation:
        return 'Barrel Horse Evaluation';
      case HorseMatrixType.Rate:
        return 'Rate';
      case HorseMatrixType.ShoulderControl:
        return 'Shoulder Control';
      case HorseMatrixType.Approach:
        return 'Approach';
      case HorseMatrixType.Takeoff:
        return 'Takeoff';
      case HorseMatrixType.FormOverJump:
        return 'Form Over Jump';
      case HorseMatrixType.Landing:
        return 'Landing';
      case HorseMatrixType.Recovery:
        return 'Recovery';
      case HorseMatrixType.Adjustability:
        return 'Adjustability';
      case HorseMatrixType.Rhythm:
        return 'Rhythm';
      case HorseMatrixType.Scope:
        return 'Scope';
      case HorseMatrixType.Movement:
        return 'Movement';
      case HorseMatrixType.JumpingStyle:
        return 'Jumping Style';
      case HorseMatrixType.Technique:
        return 'Technique';
      case HorseMatrixType.Conformation:
        return 'Conformation';
      case HorseMatrixType.Temperament:
        return 'Temperament';
      case HorseMatrixType.Expression:
        return 'Expression';
      case HorseMatrixType.WayOfGoing:
        return 'Way Of Going';
      case HorseMatrixType.Presence:
        return 'Presence';
      case HorseMatrixType.TrailObstacleNavigation:
        return 'Trail Obstacle Navigation';
      case HorseMatrixType.TemperamentOnTrail:
        return 'Temperament On Trail';
      case HorseMatrixType.TrailConfidence:
        return 'Trail Confidence';
      case HorseMatrixType.TrailRidingManners:
        return 'Trail Riding Manners';
      case HorseMatrixType.GroundManners:
        return 'Ground Manners';
      case HorseMatrixType.EaseOfHandling:
        return 'Ease Of Handling';
      case HorseMatrixType.ToleranceForNewScenarios:
        return 'Tolerance For New Scenarios';
      case HorseMatrixType.Suppleness:
        return 'Suppleness';
      case HorseMatrixType.Collection:
        return 'Collection';
      case HorseMatrixType.Balance:
        return 'Balance';
      case HorseMatrixType.Impulsion:
        return 'Impulsion';
      case HorseMatrixType.Submission:
        return 'Submission';
      case HorseMatrixType.Connection:
        return 'Connection';
      case HorseMatrixType.Harmony:
        return 'Harmony';
      case HorseMatrixType.BarrelRacingRate:
        return 'Rate';
      case HorseMatrixType.BarrelRacingShoulderControl:
        return 'Shoulder Control';
      case HorseMatrixType.BarrelRacingHipControl:
        return 'Hip Control';
      case HorseMatrixType.BarrelRacingChangingLeads:
        return 'Changing Leads';
      case HorseMatrixType.BarrelRacingRespondsToSeat:
        return 'Responds to Seat';
      case HorseMatrixType.GroundWorkCatch:
        return 'Catch';
      case HorseMatrixType.GroundWorkLead:
        return 'Lead';
      case HorseMatrixType.GroundWorkStandToSaddle:
        return 'Stand to Saddle';
      case HorseMatrixType.GroundWorkAcceptBridle:
        return 'Accept Bridle';
      case HorseMatrixType.GroundWorkStandWhileMounting:
        return 'Stand While Mounting';
      case HorseMatrixType.GroundWorkLoadInTrailer:
        return 'Load in Trailer';
      case HorseMatrixType.GroundWorkPickUpHandleFeet:
        return 'Pick Up/Handle Feet';
      case HorseMatrixType.GroundWorkGroomingClipping:
        return 'Grooming/Clipping';
      default:
        return '';
    }
  }

  export const members: HorseMatrixType[] = [
    HorseMatrixType.Trainability,
    HorseMatrixType.Willingness,
    HorseMatrixType.Confidence,
    HorseMatrixType.Curiosity,
    HorseMatrixType.Consistency,
    HorseMatrixType.Patience,
    HorseMatrixType.Focus,
    HorseMatrixType.Sensitivity,
    HorseMatrixType.FrontLegsBase,
    HorseMatrixType.FrontKneesFrontView,
    HorseMatrixType.FrontToes,
    HorseMatrixType.FrontLegsCamp,
    HorseMatrixType.FrontKneesSideView,
    HorseMatrixType.HindLegsStanding,
    HorseMatrixType.HindLegsStanding,
    HorseMatrixType.Hocks,
    HorseMatrixType.HindEnd,
    HorseMatrixType.PasternsFront,
    HorseMatrixType.PasternsHind,
    HorseMatrixType.FlightOfTravelHind,
    HorseMatrixType.BackSwayVsRoach,
    HorseMatrixType.Chest,
    HorseMatrixType.LeftSideFlexion,
    HorseMatrixType.RightSideFlexion,
    HorseMatrixType.ResponsivenessHoldsToBit,
    HorseMatrixType.ResponsivenessRespondsToRein,
    HorseMatrixType.ResponsivenessRespondsToLeg,
    HorseMatrixType.ResponsivenessRespondsToSeat,
    HorseMatrixType.ResponsivenessCollectionOfHorse,
    HorseMatrixType.MaintainingEvenGaitsWalkToRight,
    HorseMatrixType.MaintainingEvenGaitsTrotToRight,
    HorseMatrixType.MaintainingEvenGaitsCanterRightLead,
    HorseMatrixType.MaintainingEvenGaitsWalkToLeft,
    HorseMatrixType.MaintainingEvenGaitsTrotToLeft,
    HorseMatrixType.MaintainingEvenGaitsCanterLopeToLeft,
    HorseMatrixType.MaintainingEvenGaitsBack,
    HorseMatrixType.MaintainingEvenGaitsHalt,
    HorseMatrixType.MaintainingCirclesWalkSmallRight,
    HorseMatrixType.MaintainingCirclesTrotRight,
    HorseMatrixType.MaintainingCirclesWalkSmallLeft,
    HorseMatrixType.MaintainingCirclesTrotLeft,
    HorseMatrixType.MaintainingCirclesCanterLargeRight,
    HorseMatrixType.MaintainingCirclesCanterLargeLeft,
    HorseMatrixType.AdvancedRightSidePass,
    HorseMatrixType.AdvancedLeftSidePass,
    HorseMatrixType.AdvancedRightHaunchTurn,
    HorseMatrixType.AdvancedLeftHaunchTurn,
    HorseMatrixType.AdvancedRightForehandTurn,
    HorseMatrixType.AdvancedLeftForehandTurn,
    HorseMatrixType.AdvancedTrotOff,
    HorseMatrixType.AdvancedLopeOffRightLead,
    HorseMatrixType.AdvancedLopeOffLeftLead,
    HorseMatrixType.AdvancedLeadChangeLtoR,
    HorseMatrixType.AdvancedLeadChangeRtoL,
    HorseMatrixType.AdvancedLopeToHalt,
    HorseMatrixType.AdvancedFigure8Simple,
    HorseMatrixType.AdvancedFigure8FlyingLead,
    HorseMatrixType.Box,
    HorseMatrixType.Boxing,
    HorseMatrixType.BoxWork,
    HorseMatrixType.CalfRopingBoxWork,
    HorseMatrixType.RunAndRate,
    HorseMatrixType.HandlingCattle,
    HorseMatrixType.Face,
    HorseMatrixType.Stop,
    HorseMatrixType.Stops,
    HorseMatrixType.Position,
    HorseMatrixType.WorkingRope,
    HorseMatrixType.LeftCircles,
    HorseMatrixType.RightCircles,
    HorseMatrixType.LeftLeadChange,
    HorseMatrixType.RightLeadChange,
    HorseMatrixType.LeftSpin,
    HorseMatrixType.RightSpin,
    HorseMatrixType.Rollback,
    HorseMatrixType.Backup,
    HorseMatrixType.HerdWork,
    HorseMatrixType.CowControl,
    HorseMatrixType.EyeAppeal,
    HorseMatrixType.Courage,
    HorseMatrixType.LooseRein,
    HorseMatrixType.TurnsOnFence,
    HorseMatrixType.Circling,
    HorseMatrixType.PositioningAndControl,
    HorseMatrixType.BarrelHorseEvaluation,
    HorseMatrixType.Rate,
    HorseMatrixType.ShoulderControl,
    HorseMatrixType.Approach,
    HorseMatrixType.Takeoff,
    HorseMatrixType.FormOverJump,
    HorseMatrixType.Landing,
    HorseMatrixType.Recovery,
    HorseMatrixType.Adjustability,
    HorseMatrixType.Rhythm,
    HorseMatrixType.Scope,
    HorseMatrixType.Movement,
    HorseMatrixType.JumpingStyle,
    HorseMatrixType.Technique,
    HorseMatrixType.Conformation,
    HorseMatrixType.Temperament,
    HorseMatrixType.Expression,
    HorseMatrixType.WayOfGoing,
    HorseMatrixType.Presence,
    HorseMatrixType.TrailObstacleNavigation,
    HorseMatrixType.TemperamentOnTrail,
    HorseMatrixType.TrailConfidence,
    HorseMatrixType.TrailRidingManners,
    HorseMatrixType.GroundManners,
    HorseMatrixType.EaseOfHandling,
    HorseMatrixType.ToleranceForNewScenarios,
    HorseMatrixType.Suppleness,
    HorseMatrixType.Collection,
    HorseMatrixType.Balance,
    HorseMatrixType.Impulsion,
    HorseMatrixType.Submission,
    HorseMatrixType.Connection,
    HorseMatrixType.Harmony,
    HorseMatrixType.BarrelRacingRate,
    HorseMatrixType.BarrelRacingShoulderControl,
    HorseMatrixType.BarrelRacingHipControl,
    HorseMatrixType.BarrelRacingChangingLeads,
    HorseMatrixType.BarrelRacingRespondsToSeat,
    HorseMatrixType.GroundWorkCatch,
    HorseMatrixType.GroundWorkLead,
    HorseMatrixType.GroundWorkStandToSaddle,
    HorseMatrixType.GroundWorkAcceptBridle,
    HorseMatrixType.GroundWorkStandWhileMounting,
    HorseMatrixType.GroundWorkLoadInTrailer,
    HorseMatrixType.GroundWorkPickUpHandleFeet,
    HorseMatrixType.GroundWorkGroomingClipping
  ];
}
